/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Requirestraining1Inputs */

const de__field_requirestraining1 = /** @type {(inputs: _Field_Requirestraining1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benötigt Schulung`)
};

/**

* @param {_Field_Requirestraining1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_requirestraining1 = /** @type {((inputs?: _Field_Requirestraining1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Requirestraining1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_requirestraining1(inputs)
});
export { _field_requirestraining1 as "_field_requiresTraining" }